const digestMessage = async (message: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(message);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return base64urlencode(hashArray);
};

const dec2hex = (dec: number) => dec.toString(16).padStart(2, '0');

// RFC 7636 §4.1 - code_verifier = 43*128unreserved, unreserved = [A-Za-z0-9-._~]
const CODE_VERIFIER_MIN_LENGTH = 43;
const CODE_VERIFIER_MAX_LENGTH = 128;
const CODE_VERIFIER_PATTERN = /^[A-Za-z0-9\-._~]+$/;
const CODE_VERIFIER_BYTES = 32;

const generateRandomString = () => {
  const array = new Uint8Array(CODE_VERIFIER_BYTES);
  const randomArray = window.crypto.getRandomValues(array);
  return Array.from(randomArray, dec2hex).join('');
};

const isValidCodeVerifier = (verifier?: string | null): verifier is string =>
  !!verifier &&
  verifier.length >= CODE_VERIFIER_MIN_LENGTH &&
  verifier.length <= CODE_VERIFIER_MAX_LENGTH &&
  CODE_VERIFIER_PATTERN.test(verifier);

const base64urlencode = (a: number[]): string => {
  let str = '';
  const bytes = new Uint8Array(a);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export { digestMessage, dec2hex, generateRandomString, isValidCodeVerifier };
